import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    modal: {
      position: "fixed",
      top: "0",
      right: "0",
      width: "688px",
      height: "100vh",
      zIndex: 1000,
      transform: "translateX(0)",
      transition: "transform 0.3s ease-in-out",
      borderRadius: "12px",
      background: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      "& p": {
        color: theme.palette.text.tertiary,
        fontWeight: 400,
        fontSize: "16px",
        margin: "4px 0 0",
        [theme.breakpoints.down("sm")]: {
          fontSize: "14px",
        },
      },
      [theme.breakpoints.down("sm")]: {
        width: "100vw",
      },
    },
    header: {
      padding: "24px 24px 0px 24px",
      display: "flex",
      flexDirection: "column",
    },
    containerTitlePlusBackIcon: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    subTitle: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.secondary,
      lineHeight: "20px",
    },
    wrapperContent: {
      padding: "20px 24px",
      flex: 1,
    },
    banner: {
      margin: "16px",
      background: theme.palette.background.brand_50,
      border: `1px solid ${theme.palette.border.brand}`,
      borderRadius: "12px",
      position: "sticky",
      top: 0,
      zIndex: 1100,
      "& .MuiAlert-message": {
        width: "100%",
      },
    },
    bannerStuck: {
      margin: "unset",
      borderRadius: "unset",
      border: "unset",
      borderBottom: `1px solid ${theme.palette.border.brand}`,
    },
    bannerBox: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    containerFormAddFinancePlan: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "100% !important",
    },
    containerInputSection: {
      display: "flex",
      flexDirection: "row",
      gap: "16px 32px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        width: "90vw",
      },
    },
    highlightedSections: {
      background: theme.palette.background.secondary,
      padding: "16px",
      maxWidth: "640px",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    lookupSelect: {
      width: "20px",
    },
    titleFiled: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.palette.text.secondary,
      maxWidth: "280px",
      minWidth: "160px",
    },
    datePicker: {
      width: "416px",
    },
    footerActions: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "24px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "80px",
      },
    },
    autocompleteWidthOverride: {
      width: "100% !important",
    },
    containerCustomInput: { maxWidth: "100%" },
    adornment: {
      marginRight: "8px",
    },
    lookupAdornment: {
      marginLeft: "-7px !important",
    },

    dropzoneSection: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      gap: "16px",
    },
    containerUploadedFilesCards: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    CardUploadedFilesInfo: {
      display: "flex",
      flexDirection: "row",
      padding: "16px",
      gap: "12px",
    },
    ContainerFileUploadedInfo: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    containerTitleAndDeleteIcon: {
      position: "relative",
    },
    DeleteIcon: {
      cursor: "pointer",
      position: "absolute",
      right: "0px",
      top: "0px",
    },
    TitleFileName: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      maxWidth: "330px",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: "500",
      lineHeight: "20px",
      color: theme.palette.text.secondary,
    },
    FileSizeTitle: {
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px",
      color: theme.palette.text.tertiary,
    },
  };
});
